export const PMTemplate = {
    getFormName() {
        return {
            // PmTemplate Section - 1
            month: '',
            year: '',
            projectId: '',
            projectAddress: '',
            targetGp: '',
            percentageCompletion: '',
            vpConstructionCommentsForAll: '',
            // costPerSF: '',
            costPerSF: '',
            costPerSFAmount: '',
            costPerSFComments: '',
            projectOnSchedule_PM: 'NO',
            projectOnSchedule_PMReason: '',
            projectOnSchedule_VPC: 'NO',
            projectOnSchedule_VPCReason: '',
            tradePartnerAdvised_PM: 'NO',
            tradePartnerAdvised_PMReason: '',
            tradePartnerAdvised_VPC: 'NO',
            tradePartnerAdvised_VPCReason: '',
            allCityAndEngineersInspection_PM: 'NO',
            allCityAndEngineersInspection_PMReason: '',
            allCityAndEngineersInspection_VPC: 'NO',
            allCityAndEngineersInspection_VPCReason: '',
            projectOnBudget_PM: 'NO',
            projectOnBudget_PMReason: '',
            projectOnBudget_VPC: 'NO',
            projectOnBudget_VPCReason: '',
            projectBaseLineSetExecution_PM: 'NO',
            projectBaseLineSetExecution_PMReason: '',
            projectBaseLineSetExecution_VPC: 'NO',
            projectBaseLineSetExecution_VPCReason: '',
            anyErrorAndDeficiencies_PM: 'NO',
            anyErrorAndDeficiencies_PMReason: '',
            anyErrorAndDeficiencies_VPC: 'NO',
            anyErrorAndDeficiencies_VPCReason: '',
            LidaLabourInBTConsistent_PM: 'NO',
            LidaLabourInBTConsistent_PMReason: '',
            LidaLabourInBTConsistent_VPC: 'NO',
            LidaLabourInBTConsistent_VPCReason: '',
            pmContructorAndMaterialBT_PM: 'NO',
            pmContructorAndMaterialBT_PMReason: '',
            pmContructorAndMaterialBT_VPC: 'NO',
            pmContructorAndMaterialBT_VPCReason: '',
            weeklyPMClientUpdateDone_PM: 'NO',
            weeklyPMClientUpdateDone_PMReason: '',
            weeklyPMClientUpdateDone_VPC: 'NO',
            weeklyPMClientUpdateDone_VPCReason: '',
            haveAllTradeMaterialBeenInspected_PM: 'NO',
            haveAllTradeMaterialBeenInspected_PMReason: '',
            haveAllTradeMaterialBeenInspected_VPC: 'NO',
            haveAllTradeMaterialBeenInspected_VPCReason: '',
            pmQCVTTodoUptoDate_PM: 'NO',
            pmQCVTTodoUptoDate_PMReason: '',
            pmQCVTTodoUptoDate_VPC: 'NO',
            pmQCVTTodoUptoDate_VPCReason: '',
            poSubAggreementUptoDate_PM: 'NO',
            poSubAggreementUptoDate_PMReason: '',
            poSubAggreementUptoDate_VPC: 'NO',
            poSubAggreementUptoDate_VPCReason: '',
            isClientHappy_PM: 'NO',
            isClientHappy_PMReason: '',
            isClientHappy_VPC: 'NO',
            isClientHappy_VPCReason: '',
            riskSafetyClientTeam_PM: 'NO',
            riskSafetyClientTeam_PMReason: '',
            riskSafetyClientTeam_VPC: 'NO',
            riskSafetyClientTeam_VPCReason: '',
            projectAddressVpComments: '',
            targetGpVpComments: '',
            percentageCompletionGpVpComments: '',
            costPerSFVpComments: '',
            projectAddressPmComments: '',



            // PmTemplate Section - 2
            inspectionsSection: [
                this.getSectionToFormList('A'),
            ],
            // geoTechInspectionDone: 'NO',
            // geoTechInspectionDateApproved: '',
            // geoTechInspectionUploadedToBT_1: 'NO',
            // geoTechInspectionPMCommnets: '',
            // geoTechInspectionUploadedToBT_2: 'NO',
            // geoTechInspection_VPcommercial: '',
            // cityGroundInspectionDone: 'NO',
            // cityGroundInspectionDateApproved: '',
            // cityGroundInspectionUploadedToBT_1: 'NO',
            // cityGroundInspectionPMCommnets: '',
            // cityGroundInspectionUploadedToBT_2: 'NO',
            // cityGroundInspection_VPcommercial: '',
            // engineerFootingInspectionDone: 'NO',
            // engineerFootingInspectionDateApproved: '',
            // engineerFootingInspectionUploadedToBT_1: 'NO',
            // engineerFootingInspectionPMCommnets: '',
            // engineerFootingInspectionUploadedToBT_2: 'NO',
            // engineerFootingInspection_VPcommercial: '',
            // cityFootingInspectionDone: 'NO',
            // cityFootingInspectionDateApproved: '',
            // cityFootingInspectionUploadedToBT_1: 'NO',
            // cityFootingInspectionPMCommnets: '',
            // cityFootingInspectionUploadedToBT_2: 'NO',
            // cityFootingInspection_VPcommercial: '',
            // engineeringWallInspectionDone: 'NO',
            // engineeringWallInspectionDateApproved: '',
            // engineeringWallInspectionUploadedToBT_1: 'NO',
            // engineeringWallInspectionPMCommnets: '',
            // engineeringWallInspectionUploadedToBT_2: 'NO',
            // engineeringWallInspection_VPcommercial: '',
            // cityWallInspectionDone: 'NO',
            // cityWallInspectionDateApproved: '',
            // cityWallInspectionUploadedToBT_1: 'NO',
            // cityWallInspectionPMCommnets: '',
            // cityWallInspectionUploadedToBT_2: 'NO',
            // cityWallInspection_VPcommercial: '',
            // cityStormDrainRWLinspectionDone: 'NO',
            // cityStormDrainRWLinspectionDateApproved: '',
            // cityStormDrainRWLinspectionUploadedToBT_1: 'NO',
            // cityStormDrainRWLinspectionPMCommnets: '',
            // cityStormDrainRWLinspectionUploadedToBT_2: 'NO',
            // cityStormDrainRWLinspection_VPcommercial: '',
            // citySewerConnectionInspectionDone: 'NO',
            // citySewerConnectionInspectionDateApproved: '',
            // citySewerConnectionInspectionUploadedToBT_1: 'NO',
            // citySewerConnectionInspectionPMCommnets: '',
            // citySewerConnectionInspectionUploadedToBT_2: 'NO',
            // citySewerConnectionInspection_VPcommercial: '',
            // cityPlumbingGroundRoughIninspectionDone: 'NO',
            // cityPlumbingGroundRoughIninspectionDateApproved: '',
            // cityPlumbingGroundRoughIninspectionUploadedToBT_1: 'NO',
            // cityPlumbingGroundRoughIninspectionPMCommnets: '',
            // cityPlumbingGroundRoughIninspectionUploadedToBT_2: 'NO',
            // cityPlumbingGroundRoughIninspection_VPcommercial: '',
            // cityGroundSealInspectionDone: 'NO',
            // cityGroundSealInspectionDateApproved: '',
            // cityGroundSealInspectionUploadedToBT_1: 'NO',
            // cityGroundSealInspectionPMCommnets: '',
            // cityGroundSealInspectionUploadedToBT_2: 'NO',
            // cityGroundSealInspection_VPcommercial: '',
            // engineeringFramingInspectionDone: 'NO',
            // engineeringFramingInspectionDateApproved: '',
            // engineeringFramingInspectionUploadedToBT_1: 'NO',
            // engineeringFramingInspectionPMCommnets: '',
            // engineeringFramingInspectionUploadedToBT_2: 'NO',
            // engineeringFramingInspection_VPcommercial: '',
            // ventChecklistSubmittedDone: 'NO',
            // ventChecklistSubmittedDateApproved: '',
            // ventChecklistSubmittedUploadedToBT_1: 'NO',
            // ventChecklistSubmittedPMCommnets: '',
            // ventChecklistSubmittedUploadedToBT_2: 'NO',
            // ventChecklistSubmitted_VPcommercial: '',
            // cityFramingInspectionDone: 'NO',
            // cityFramingInspectionDateApproved: '',
            // cityFramingInspectionUploadedToBT_1: 'NO',
            // cityFramingInspectionPMCommnets: '',
            // cityFramingInspectionUploadedToBT_2: 'NO',
            // cityFramingInspection_VPcommercial: '',
            // citySheetingInspectionDone: 'NO',
            // citySheetingInspectionDateApproved: '',
            // citySheetingInspectionUploadedToBT_1: 'NO',
            // citySheetingInspectionPMCommnets: '',
            // citySheetingInspectionUploadedToBT_2: 'NO',
            // citySheetingInspection_VPcommercial: '',
            // cityRainScreenInspectionDone: 'NO',
            // cityRainScreenInspectionDateApproved: '',
            // cityRainScreenInspectionUploadedToBT_1: 'NO',
            // cityRainScreenInspectionPMCommnets: '',
            // cityRainScreenInspectionUploadedToBT_2: 'NO',
            // cityRainScreenInspection_VPcommercial: '',
            // cityStuccoWireInspectionDone: 'NO',
            // cityStuccoWireInspectionDateApproved: '',
            // cityStuccoWireInspectionUploadedToBT_1: 'NO',
            // cityStuccoWireInspectionPMCommnets: '',
            // cityStuccoWireInspectionUploadedToBT_2: 'NO',
            // cityStuccoWireInspection_VPcommercial: '',
            // cityElectricalRoughInspectionDone: 'NO',
            // cityElectricalRoughInspectionDateApproved: '',
            // cityElectricalRoughInspectionUploadedToBT_1: 'NO',
            // cityElectricalRoughInspectionPMCommnets: '',
            // cityElectricalRoughInspectionUploadedToBT_2: 'NO',
            // cityElectricalRoughInspection_VPcommercial: '',
            // cityPlumbingRoughInInspectionDone: 'NO',
            // cityPlumbingRoughInInspectionDateApproved: '',
            // cityPlumbingRoughInInspectionUploadedToBT_1: 'NO',
            // cityPlumbingRoughInInspectionPMCommnets: '',
            // cityPlumbingRoughInInspectionUploadedToBT_2: 'NO',
            // cityPlumbingRoughInInspection_VPcommercial: '',
            // cityInsulationInspectionDone: 'NO',
            // cityInsulationInspectionDateApproved: '',
            // cityInsulationInspectionUploadedToBT_1: 'NO',
            // cityInsulationInspectionPMCommnets: '',
            // cityInsulationInspectionUploadedToBT_2: 'NO',
            // cityInsulationInspection_VPcommercial: '',
            // initialBlowerDoorTestDone: 'NO',
            // initialBlowerDoorTestDateApproved: '',
            // initialBlowerDoorTestUploadedToBT_1: 'NO',
            // initialBlowerDoorTestPMCommnets: '',
            // initialBlowerDoorTestUploadedToBT_2: 'NO',
            // initialBlowerDoorTest_VPcommercial: '',
            // aerobarrierFinalBlowerDoorTestDone: 'NO',
            // aerobarrierFinalBlowerDoorTestDateApproved: '',
            // aerobarrierFinalBlowerDoorTestUploadedToBT_1: 'NO',
            // aerobarrierFinalBlowerDoorTestPMCommnets: '',
            // aerobarrierFinalBlowerDoorTestUploadedToBT_2: 'NO',
            // aerobarrierFinalBlowerDoorTest_VPcommercial: '',
            // cityFinalInspectionDone: 'NO',
            // cityFinalInspectionDateApproved: '',
            // cityFinalInspectionUploadedToBT_1: 'NO',
            // cityFinalInspectionPMCommnets: '',
            // cityFinalInspectionUploadedToBT_2: 'NO',
            // cityFinalInspection_VPcommercial: '',
            // heatLossCalReportDone: '',
            // heatLossCalReportDateApproved: '',
            // heatLossCalReportUploadedToBT_1: '',
            // heatLossCalReportPMCommnets: '',
            // heatLossCalReportUploadedToBT_2: '',
            // heatLossCalReport_VPcommercial: '',



            // PmTemplate Section - 3
            lidaHomesProjectManagement6050EHP_WINGR: '',
            lidaHomesProjectManagement6050EPMINGR: '',
            lidaHomesProjectManagement6050CBA: '',
            lidaHomesProjectManagement6050BU: '',
            lidaHomesProjectManagement6050RB: '',
            lidaHomesProjectManagement6050COR: '',
            lidaHomesProjectManagement6050PCD: '',
            lidaHomesProjectManagement6050EHTCP_M: '',
            lidaHomesProjectManagement6050EOMTC: '',
            lidaHomesProjectManagement6050PHTC: '',
            lidaHomesProjectManagement6050PBTC: '',
            lidaHomesProjectManagement6050P_MB: '',
            lidaHomesProjectManagement6050C: '',
            specsAndBiddind0405EHP_WINGR: '',
            specsAndBidding0405EPMINGR: '',
            specsAndBidding0405CBA: '',
            specsAndBidding0405BU: '',
            specsAndBidding0405RB: '',
            specsAndBidding0405COR: '',
            specsAndBidding0405PCD: '',
            specsAndBidding0405EHTCP_M: '',
            specsAndBidding0405EOMTC: '',
            specsAndBidding0405PHTC: '',
            specsAndBidding0405PBTC: '',
            specsAndBidding0405P_MB: '',
            specsAndBidding0405C: '',
            idAdmin0404EHP_WINGR: '',
            idAdmin0404EPMINGR: '',
            idAdmin0404CBA: '',
            idAdmin0404BU: '',
            idAdmin0404RB: '',
            idAdmin0404COR: '',
            idAdmin0404PCD: '',
            idAdmin0404EHTCP_M: '',
            idAdmin0404EOMTC: '',
            idAdmin0404PHTC: '',
            idAdmin0404PBTC: '',
            idAdmin0404P_MB: '',
            idAdmin0404C: '',
            idSpecsAndBidding0405EHP_WINGR: '',
            idSpecsAndBidding0405EPMINGR: '',
            idSpecsAndBidding0405CBA: '',
            idSpecsAndBidding0405BU: '',
            idSpecsAndBidding0405RB: '',
            idSpecsAndBidding0405COR: '',
            idSpecsAndBidding0405PCD: '',
            idSpecsAndBidding0405EHTCP_M: '',
            idSpecsAndBidding0405EOMTC: '',
            idSpecsAndBidding0405PHTC: '',
            idSpecsAndBidding0405PBTC: '',
            idSpecsAndBidding0405P_MB: '',
            idSpecsAndBidding0405C: '',
            flatworkPrepLabour0810EHP_WINGR: '',
            flatworkPrepLabour0810EPMINGR: '',
            flatworkPrepLabour0810CBA: '',
            flatworkPrepLabour0810BU: '',
            flatworkPrepLabour0810RB: '',
            flatworkPrepLabour0810COR: '',
            flatworkPrepLabour0810PCD: '',
            flatworkPrepLabour0810EHTCP_M: '',
            flatworkPrepLabour0810EOMTC: '',
            flatworkPrepLabour0810PHTC: '',
            flatworkPrepLabour0810PBTC: '',
            flatworkPrepLabour0810P_MB: '',
            flatworkPrepLabour0810C: '',
            foundationMaterial0821EHP_WINGR: '',
            foundationMaterial0821EPMINGR: '',
            foundationMaterial0821CBA: '',
            foundationMaterial0821BU: '',
            foundationMaterial0821RB: '',
            foundationMaterial0821COR: '',
            foundationMaterial0821PCD: '',
            foundationMaterial0821EHTCP_M: '',
            foundationMaterial0821EOMTC: '',
            foundationMaterial0821PHTC: '',
            foundationMaterial0821PBTC: '',
            foundationMaterial0821P_MB: '',
            foundationMaterial0821C: '',
            framing0904EHP_WINGR: '',
            framing0904EPMINGR: '',
            framing0904CBA: '',
            framing0904BU: '',
            framing0904RB: '',
            framing0904COR: '',
            framing0904PCD: '',
            framing0904EHTCP_M: '',
            framing0904EOMTC: '',
            framing0904PHTC: '',
            framing0904PBTC: '',
            framing0904P_MB: '',
            framing0904C: '',
            backFramingLabour0906EHP_WINGR: '',
            backFramingLabour0906EPMINGR: '',
            backFramingLabour0906CBA: '',
            backFramingLabour0906BU: '',
            backFramingLabour0906RB: '',
            backFramingLabour0906COR: '',
            backFramingLabour0906PCD: '',
            backFramingLabour0906EHTCP_M: '',
            backFramingLabour0906EOMTC: '',
            backFramingLabour0906PHTC: '',
            backFramingLabour0906PBTC: '',
            backFramingLabour0906P_MB: '',
            backFramingLabour0906C: '',
            anyOtherLidaLabour668_684_706_829EHP_WINGR: '',
            anyOtherLidaLabour668_684_706_829EPMINGR: '',
            anyOtherLidaLabour668_684_706_829CBA: '',
            anyOtherLidaLabour668_684_706_829BU: '',
            anyOtherLidaLabour668_684_706_829RB: '',
            anyOtherLidaLabour668_684_706_829COR: '',
            anyOtherLidaLabour668_684_706_829PCD: '',
            anyOtherLidaLabour668_684_706_829EHTCP_M: '',
            anyOtherLidaLabour668_684_706_829EOMTC: '',
            anyOtherLidaLabour668_684_706_829PHTC: '',
            anyOtherLidaLabour668_684_706_829PBTC: '',
            anyOtherLidaLabour668_684_706_829P_MB: '',
            anyOtherLidaLabour668_684_706_829C: '',
            drivewayPatioPrep0830EHP_WINGR: '',
            drivewayPatioPrep0830EPMINGR: '',
            drivewayPatioPrep0830CBA: '',
            drivewayPatioPrep0830BU: '',
            drivewayPatioPrep0830RB: '',
            drivewayPatioPrep0830COR: '',
            drivewayPatioPrep0830PCD: '',
            drivewayPatioPrep0830EHTCP_M: '',
            drivewayPatioPrep0830EOMTC: '',
            drivewayPatioPrep0830PHTC: '',
            drivewayPatioPrep0830PBTC: '',
            drivewayPatioPrep0830P_MB: '',
            drivewayPatioPrep0830C: '',

            section_3: [
                {

                    ListAllLIDALabour: 'LIDA Homes Project Management(6050)',
                    EstimatedHoursGR: '',
                    EstimatedProjectMonthsInGR: '',
                    ContractBudgetAmount: '',
                    BudgetUsed: '',
                    RemainingBudget: '',
                    ChargeOutRate: '',
                    ProjectedCompletionDate: '',
                    EstimatedHoursToCompletePM: '',
                    EstimatedOfMonthsToCompete: '',
                    ProjectedHoursToComplete: '',
                    ProjectedBudgetToCompete: '',
                    PlusMinusBudget: '',
                    Comments: '',
                },
                {

                    ListAllLIDALabour: 'Specs & Bidding(0405)',
                    EstimatedHoursGR: '',
                    EstimatedProjectMonthsInGR: '',
                    ContractBudgetAmount: '',
                    BudgetUsed: '',
                    RemainingBudget: '',
                    ChargeOutRate: '',
                    ProjectedCompletionDate: '',
                    EstimatedHoursToCompletePM: '',
                    EstimatedOfMonthsToCompete: '',
                    ProjectedHoursToComplete: '',
                    ProjectedBudgetToCompete: '',
                    PlusMinusBudget: '',
                    Comments: '',
                },
                {

                    ListAllLIDALabour: 'ID Admin(0404)',
                    EstimatedHoursGR: '',
                    EstimatedProjectMonthsInGR: '',
                    ContractBudgetAmount: '',
                    BudgetUsed: '',
                    RemainingBudget: '',
                    ChargeOutRate: '',
                    ProjectedCompletionDate: '',
                    EstimatedHoursToCompletePM: '',
                    EstimatedOfMonthsToCompete: '',
                    ProjectedHoursToComplete: '',
                    ProjectedBudgetToCompete: '',
                    PlusMinusBudget: '',
                    Comments: '',
                },
                {

                    ListAllLIDALabour: 'ID Specs & Bidding(0405)',
                    EstimatedHoursGR: '',
                    EstimatedProjectMonthsInGR: '',
                    ContractBudgetAmount: '',
                    BudgetUsed: '',
                    RemainingBudget: '',
                    ChargeOutRate: '',
                    ProjectedCompletionDate: '',
                    EstimatedHoursToCompletePM: '',
                    EstimatedOfMonthsToCompete: '',
                    ProjectedHoursToComplete: '',
                    ProjectedBudgetToCompete: '',
                    PlusMinusBudget: '',
                    Comments: '',
                },
                {

                    ListAllLIDALabour: 'Flatwork Prep Labour(0810)',
                    EstimatedHoursGR: '',
                    EstimatedProjectMonthsInGR: '',
                    ContractBudgetAmount: '',
                    BudgetUsed: '',
                    RemainingBudget: '',
                    ChargeOutRate: '',
                    ProjectedCompletionDate: '',
                    EstimatedHoursToCompletePM: '',
                    EstimatedOfMonthsToCompete: '',
                    ProjectedHoursToComplete: '',
                    ProjectedBudgetToCompete: '',
                    PlusMinusBudget: '',
                    Comments: '',
                },
                {

                    ListAllLIDALabour: 'Foundation Material(0821)',
                    EstimatedHoursGR: '',
                    EstimatedProjectMonthsInGR: '',
                    ContractBudgetAmount: '',
                    BudgetUsed: '',
                    RemainingBudget: '',
                    ChargeOutRate: '',
                    ProjectedCompletionDate: '',
                    EstimatedHoursToCompletePM: '',
                    EstimatedOfMonthsToCompete: '',
                    ProjectedHoursToComplete: '',
                    ProjectedBudgetToCompete: '',
                    PlusMinusBudget: '',
                    Comments: '',
                },
                {

                    ListAllLIDALabour: 'Framing(0904)',
                    EstimatedHoursGR: '',
                    EstimatedProjectMonthsInGR: '',
                    ContractBudgetAmount: '',
                    BudgetUsed: '',
                    RemainingBudget: '',
                    ChargeOutRate: '',
                    ProjectedCompletionDate: '',
                    EstimatedHoursToCompletePM: '',
                    EstimatedOfMonthsToCompete: '',
                    ProjectedHoursToComplete: '',
                    ProjectedBudgetToCompete: '',
                    PlusMinusBudget: '',
                    Comments: '',
                },
                {

                    ListAllLIDALabour: 'Back framing labour(0906)',
                    EstimatedHoursGR: '',
                    EstimatedProjectMonthsInGR: '',
                    ContractBudgetAmount: '',
                    BudgetUsed: '',
                    RemainingBudget: '',
                    ChargeOutRate: '',
                    ProjectedCompletionDate: '',
                    EstimatedHoursToCompletePM: '',
                    EstimatedOfMonthsToCompete: '',
                    ProjectedHoursToComplete: '',
                    ProjectedBudgetToCompete: '',
                    PlusMinusBudget: '',
                    Comments: '',
                },
                {

                    ListAllLIDALabour: 'Any other LIDA Labour(668,684,706,829)',
                    EstimatedHoursGR: '',
                    EstimatedProjectMonthsInGR: '',
                    ContractBudgetAmount: '',
                    BudgetUsed: '',
                    RemainingBudget: '',
                    ChargeOutRate: '',
                    ProjectedCompletionDate: '',
                    EstimatedHoursToCompletePM: '',
                    EstimatedOfMonthsToCompete: '',
                    ProjectedHoursToComplete: '',
                    ProjectedBudgetToCompete: '',
                    PlusMinusBudget: '',
                    Comments: '',
                },
                {

                    ListAllLIDALabour: 'Driveway/Patio Prep(0830)',
                    EstimatedHoursGR: '',
                    EstimatedProjectMonthsInGR: '',
                    ContractBudgetAmount: '',
                    BudgetUsed: '',
                    RemainingBudget: '',
                    ChargeOutRate: '',
                    ProjectedCompletionDate: '',
                    EstimatedHoursToCompletePM: '',
                    EstimatedOfMonthsToCompete: '',
                    ProjectedHoursToComplete: '',
                    ProjectedBudgetToCompete: '',
                    PlusMinusBudget: '',
                    Comments: '',
                },

            ],
            // PmTemplate Section - 4
            orgEstimatedContractDurationMonths: '',
            actualContractDurationMonths: '',
            monthsOfSlippageMonths: '',
            originalExpectedGP: '',
            originalGPMonths: '',
            newExpectedGP: '',
            updatedGPMonths: '',
            gpTermsOfProjectPerMonths: '',
            gpTermsOfProject: '',
            perOfGPSlippage: '',

            // PmTemplate Section - 5

            markupBudget: '',
            markupBudgetUsed: '',
            markupRemainingBudget: '',
            markupVPCOPSCO: '',
            overheadBudget: '',
            overheadBudgetUsed: '',
            overheadRemainingBudget: '',
            overheadVPCOPSCO: '',
            deliveryChargeBudget: '',
            deliveryChargeBudgetUsed: '',
            deliveryChargeRemainingBudget: '',
            deliveryChargeVPCOPSCO: '',
            equipmentAndToolUsageBudget: '',
            equipmentAndToolUsageBudgetUsed: '',
            equipmentAndToolUsageRemainingBudget: '',
            equipmentAndToolUsageVPCOPSCO: '',
            liabilityInsuranceBudget: '',
            liabilityInsuranceBudgetUsed: '',
            liabilityInsuranceRemainingBudget: '',
            liabilityInsuranceVPCOPSCO: '',
            siteSafetyManagementBudget: '',
            siteSafetyManagementBudgetUsed: '',
            siteSafetyManagementRemainingBudget: '',
            siteSafetyManagementVPCOPSCO: '',
            siteSecurityStorageBudget: '',
            siteSecurityStorageBudgetUsed: '',
            siteSecurityStorageRemainingBudget: '',
            siteSecurityStorageVPCOPSCO: '',
            tempFansAndHeatersBudget: '',
            tempFansAndHeatersBudgetUsed: '',
            tempFansAndHeatersRemainingBudget: '',
            tempFansAndHeatersVPCOPSCO: '',
            markupWhenToInvoice: '20% contract sign, 20% foundation complete, 20% lock up, 20% rough in complete, 10% drywall complete, 5% cabinets installed, 5% substantial completion - 5% cabinets milestone being billed on next client invoice Feb 15/23',
            overheadWhenToInvoice: 'Same as above',
            deliveryChargeWhenToInvoice: 'Billing on going',
            equipmentAndToolUsageToInvoice: '50% at first invoice after excavation, 50% lock up',
            liabilityInsuranceWhenToInvoice: '50% at first invoice after excavation, 50% lock up',
            siteSafetyManagementWhenToInvoice: '50% at first invoice after excavation, 50% lock up',
            tempFansAndHeatersWhenToInvoice: 'Being billed on next client invoice Feb 15/23',
            siteSecurityStorageWhenToInvoice: '50% at first invoice after excavation, 50% lock up',


            // PmTemplate Section - 6
            section_6: [
                {
                    monthClientRating: 'Jan',
                    ClientRating: '1',
                    clientComment: '',
                    VpConstructionComment: '',
                },
                {
                    monthClientRating: 'Feb',
                    ClientRating: '1',
                    clientComment: '',
                    VpConstructionComment: '',
                },
                {
                    monthClientRating: 'Mar',
                    ClientRating: '1',
                    clientComment: '',
                    VpConstructionComment: '',
                },
                {
                    monthClientRating: 'Apr',
                    ClientRating: '1',
                    clientComment: '',
                    VpConstructionComment: '',
                },
                {
                    monthClientRating: 'May',
                    ClientRating: '1',
                    clientComment: '',
                    VpConstructionComment: '',
                },
                {
                    monthClientRating: 'Jun',
                    ClientRating: '1',
                    clientComment: '',
                    VpConstructionComment: '',
                },
                {
                    monthClientRating: 'Jul',
                    ClientRating: '1',
                    clientComment: '',
                    VpConstructionComment: '',
                },
                {
                    monthClientRating: 'Aug',
                    ClientRating: '1',
                    clientComment: '',
                    VpConstructionComment: '',
                },
                {
                    monthClientRating: 'Sep',
                    ClientRating: '1',
                    clientComment: '',
                    VpConstructionComment: '',
                },
                {
                    monthClientRating: 'Oct',
                    ClientRating: '1',
                    clientComment: '',
                    VpConstructionComment: '',
                },
                {
                    monthClientRating: 'Nov',
                    ClientRating: '1',
                    clientComment: '',
                    VpConstructionComment: '',
                },
                {
                    monthClientRating: 'Dec',
                    ClientRating: '1',
                    clientComment: '',
                    VpConstructionComment: '',
                },


            ],
            // monthClientRating: [],
            // ClientRating:[],
            // clientComment: [],
            // VpConstructionComment: [],

            // PmTemplate Section - 7
            dear: '',
            dearVPCComments: '',
            hereIsYourWeeklySummaryFrom: '',
            hereIsYourWeeklySummaryTo: '',
            hereIsYourWeeklySummaryVPCComments: '',
            projectSummary: '',
            projectSummaryVPCComments: '',
            scheduleConstructionStartDate: '',
            scheduleProjectCompletion: '',
            scheduleVPCComments: '',

            // PmTemplate Section - 8
            //* ----------Suraj--------

            scheduleMilestonesSectionList: [
                this.getScheduleMilestonesSection('A'),
            ],

            // sitePrep_P_B_C_Date: '',
            // sitePrep_C_F_C_Date: '',
            // sitePrep_A_C_Date: '',
            // sitePrep_Notes: '',
            // sitePrep_VP_C_Comments: '',
            // demolitionAndSurvey_P_B_C_Date: '',
            // demolitionAndSurvey_C_F_C_Date: '',
            // demolitionAndSurvey_A_C_Date: '',
            // demolitionAndSurvey_Notes: '',
            // demolitionAndSurvey_VP_C_Comments: '',
            // footingAndFoundation_P_B_C_Date: '',
            // footingAndFoundation_C_F_C_Date: '',
            // footingAndFoundation_A_C_Date: '',
            // footingAndFoundation_Notes: '',
            // footingAndFoundation_VP_C_Comments: '',
            // framing_P_B_C_Date: '',
            // framing_C_F_C_Date: '',
            // framing_A_C_Date: '',
            // framing_Notes: '',
            // framing_VP_C_Comments: '',
            // roofingAndMechanical_P_B_C_Date: '',
            // roofingAndMechanical_C_F_C_Date: '',
            // roofingAndMechanical_A_C_Date: '',
            // roofingAndMechanical_Notes: '',
            // roofingAndMechanical_VP_C_Comments: '',
            // exteriorFinish_P_B_C_Date: '',
            // exteriorFinish_C_F_C_Date: '',
            // exteriorFinish_A_C_Date: '',
            // exteriorFinish_Notes: '',
            // exteriorFinish_VP_C_Comments: '',
            // insulationAndDrywall_P_B_C_Date: '',
            // insulationAndDrywall_C_F_C_Date: '',
            // insulationAndDrywall_A_C_Date: '',
            // insulationAndDrywall_Notes: '',
            // insulationAndDrywall_VP_C_Comments: '',
            // Completion_P_B_C_Date: '',
            // Completion_C_F_C_Date: '',
            // Completion_A_C_Date: '',
            // Completion_Notes: '',
            // Completion_VP_C_Comments: '',
            // turnOver_P_B_C_Date: '',
            // turnOver_C_F_C_Date: '',
            // turnOver_A_C_Date: '',
            // turnOver_Notes: '',
            // turnOver_VP_C_Comments: '',
            //* -----------------


            // PmTemplate Section - 9
            // activitiesworkedOnThisWeek: '',
            //Constractor: '',
            //briefScopeOfWeek: '',
            //sitePrep_Notes_9: '',
            //CurrentForecastedCompletionDate: '',
            //VPConstructionComment_9: '',

            section_9: [
                {
                    activitiesworkedOnThisWeek: '',
                    Constractor: '',
                    briefScopeOfWeek: '',
                    sitePrep_Notes_9: '',
                    CurrentForecastedCompletionDate: '',
                    VPConstructionComment: '',

                }
            ],

            // PmTemplate Section - 10
            section_10: [{
                activitiesScheduledOnNextWeek: '',
                Constractor: '',
                briefScopeOfWeek: '',
                sitePrep_Notes_10: '',
                CurrentForecastedCompletionDate: '',
                VPConstructionComment: '',
            }],
            // activitiesScheduledOnNextWeek: '',
            // Constractor_10: '',
            // briefScopeOfWeek_10: '',
            // sitePrep_Notes_10: '',
            // CurrentForecastedCompletionDate_10: '',
            // VPConstructionComment_10: '',

            // PmTemplate Section - 11
            contractPriceAmount: '',
            contractPriceVPCComment: '',
            approvedChangeOrderPrice: '',
            approvedChangeOrderVPCComment: '',
            allowanceDiffrence: '',
            allowanceDiffrenceVPCComment: '',
            jobRunningTotal: '',
            jobRunningTotalVPCComment: '',
            gst: '',
            gstVPCComment: '',
            amountPaid: '',
            amountPaidVPCComment: '',
            balance: '',
            balanceVPCComment: '',

            // PmTemplate Section - 12
            contractDepositsAmount: '',
            contractDepositsVPCComments: '',
            buildingPermitDepositAmount: '',
            buildingPermitDepositVPCComments: '',
            otherDepositAmount: '',
            otherDepositVPCComments: '',
            totalDepositAmount: '',
            totalDepositVPCComments: '',

            // PmTemplate Section - 13
            section_13: [{
                changeWorkOrder: '',
                date: '',
                amount: '',
                approved: 'NO',
                notes: '',
                VPCComments: '',
            }],
            // changeWorkOrder: '',
            // date: '',
            // amount: '',
            // approved: '',
            // notes: '',
            // VPCComments: '',

            // PmTemplate Section - 14
            section_14: [{
                actionItemDiscussed: '',
                vpConstructionComments: '',
            }],
            // actionItemDiscussed: '',
            // vpConstructionComments: '',

            // PmTemplate Section - 15
            address: '',
            dateOfMeeting: '',
            whoIsPresentForAutopsy: '',
            projectManager: '',
            interiorDesigner: '',
            foreman: '',
            projectSummary_15: '',


            // Section 16
            wins: '',
            losses: '',
            whatDidWeDoWell: '',
            WhereCouldWeMakeImprovements: '',
            WhatTradesWereExcellentAndWhy: '',
            WhatTradesWereAProblemAndWhy: '',

            // secton 17
            ProjectManager_1: '',
            PMPOINTS_1: '',
            VPPOINTS_1: '',
            PMCOMMENTS_1: '',
            VPCOCOMMENTS_1: '',
            ProjectManager_2: '',
            PMPOINTS_2: '',
            VPPOINTS_2: '',
            PMCOMMENTS_2: '',
            VPCOCOMMENTS_2: '',
            ProjectManager_3: '',
            PMPOINTS_3: '',
            VPPOINTS_3: '',
            PMCOMMENTS_3: '',
            VPCOCOMMENTS_3: '',
            ProjectManager_4: '',
            PMPOINTS_4: '',
            VPPOINTS_4: '',
            PMCOMMENTS_4: '',
            VPCOCOMMENTS_4: '',
            ProjectManager_5: '',
            PMPOINTS_5: '',
            VPPOINTS_5: '',
            PMCOMMENTS_5: '',
            VPCOCOMMENTS_5: '',
            ProjectManager_6: '',
            PMPOINTS_6: '',
            VPPOINTS_6: '',
            PMCOMMENTS_6: '',
            VPCOCOMMENTS_6: '',
            // secton 18

            ConstructionBestPratices: '',
            ConstructionChallenges: '',
            EnergyPerformanceDocument: '',
            SelectionOfMaterialsAndResources: '',
            EnergyAndWaterSavingConsiderations: '',
            InnovationAndDesign: '',
            SensitivityToSiteConditions: '',
            AnyDetailsNotMentionedAbove: '',
            SalesAndMarketingMaterial: '',


            // Back Charges and Fee and Reimbursables
            backCharges: [],
            feeAndReimbursables: [],
            backCharges: [],
            feeAndReimbursables: [],               
 
        }     

    },

    getSectionToFormList(sec) {
        return {
            inspections_section: sec,
            geoTechInspectionDone: 'NO',
            geoTechInspectionDateApproved: '',
            geoTechInspectionUploadedToBT_1: 'NO',
            geoTechInspectionPMCommnets: '',
            geoTechInspectionUploadedToBT_2: 'NO',
            geoTechInspection_VPcommercial: '',
            cityGroundInspectionDone: 'NO',
            cityGroundInspectionDateApproved: '',
            cityGroundInspectionUploadedToBT_1: 'NO',
            cityGroundInspectionPMCommnets: '',
            cityGroundInspectionUploadedToBT_2: 'NO',
            cityGroundInspection_VPcommercial: '',
            engineerFootingInspectionDone: 'NO',
            engineerFootingInspectionDateApproved: '',
            engineerFootingInspectionUploadedToBT_1: 'NO',
            engineerFootingInspectionPMCommnets: '',
            engineerFootingInspectionUploadedToBT_2: 'NO',
            engineerFootingInspection_VPcommercial: '',
            cityFootingInspectionDone: 'NO',
            cityFootingInspectionDateApproved: '',
            cityFootingInspectionUploadedToBT_1: 'NO',
            cityFootingInspectionPMCommnets: '',
            cityFootingInspectionUploadedToBT_2: 'NO',
            cityFootingInspection_VPcommercial: '',
            engineeringWallInspectionDone: 'NO',
            engineeringWallInspectionDateApproved: '',
            engineeringWallInspectionUploadedToBT_1: 'NO',
            engineeringWallInspectionPMCommnets: '',
            engineeringWallInspectionUploadedToBT_2: 'NO',
            engineeringWallInspection_VPcommercial: '',
            cityWallInspectionDone: 'NO',
            cityWallInspectionDateApproved: '',
            cityWallInspectionUploadedToBT_1: 'NO',
            cityWallInspectionPMCommnets: '',
            cityWallInspectionUploadedToBT_2: 'NO',
            cityWallInspection_VPcommercial: '',
            cityStormDrainRWLinspectionDone: 'NO',
            cityStormDrainRWLinspectionDateApproved: '',
            cityStormDrainRWLinspectionUploadedToBT_1: 'NO',
            cityStormDrainRWLinspectionPMCommnets: '',
            cityStormDrainRWLinspectionUploadedToBT_2: 'NO',
            cityStormDrainRWLinspection_VPcommercial: '',
            citySewerConnectionInspectionDone: 'NO',
            citySewerConnectionInspectionDateApproved: '',
            citySewerConnectionInspectionUploadedToBT_1: 'NO',
            citySewerConnectionInspectionPMCommnets: '',
            citySewerConnectionInspectionUploadedToBT_2: 'NO',
            citySewerConnectionInspection_VPcommercial: '',
            cityPlumbingGroundRoughIninspectionDone: 'NO',
            cityPlumbingGroundRoughIninspectionDateApproved: '',
            cityPlumbingGroundRoughIninspectionUploadedToBT_1: 'NO',
            cityPlumbingGroundRoughIninspectionPMCommnets: '',
            cityPlumbingGroundRoughIninspectionUploadedToBT_2: 'NO',
            cityPlumbingGroundRoughIninspection_VPcommercial: '',
            cityGroundSealInspectionDone: 'NO',
            cityGroundSealInspectionDateApproved: '',
            cityGroundSealInspectionUploadedToBT_1: 'NO',
            cityGroundSealInspectionPMCommnets: '',
            cityGroundSealInspectionUploadedToBT_2: 'NO',
            cityGroundSealInspection_VPcommercial: '',
            engineeringFramingInspectionDone: 'NO',
            engineeringFramingInspectionDateApproved: '',
            engineeringFramingInspectionUploadedToBT_1: 'NO',
            engineeringFramingInspectionPMCommnets: '',
            engineeringFramingInspectionUploadedToBT_2: 'NO',
            engineeringFramingInspection_VPcommercial: '',
            ventChecklistSubmittedDone: 'NO',
            ventChecklistSubmittedDateApproved: '',
            ventChecklistSubmittedUploadedToBT_1: 'NO',
            ventChecklistSubmittedPMCommnets: '',
            ventChecklistSubmittedUploadedToBT_2: 'NO',
            ventChecklistSubmitted_VPcommercial: '',
            cityFramingInspectionDone: 'NO',
            cityFramingInspectionDateApproved: '',
            cityFramingInspectionUploadedToBT_1: 'NO',
            cityFramingInspectionPMCommnets: '',
            cityFramingInspectionUploadedToBT_2: 'NO',
            cityFramingInspection_VPcommercial: '',
            citySheetingInspectionDone: 'NO',
            citySheetingInspectionDateApproved: '',
            citySheetingInspectionUploadedToBT_1: 'NO',
            citySheetingInspectionPMCommnets: '',
            citySheetingInspectionUploadedToBT_2: 'NO',
            citySheetingInspection_VPcommercial: '',
            cityRainScreenInspectionDone: 'NO',
            cityRainScreenInspectionDateApproved: '',
            cityRainScreenInspectionUploadedToBT_1: 'NO',
            cityRainScreenInspectionPMCommnets: '',
            cityRainScreenInspectionUploadedToBT_2: 'NO',
            cityRainScreenInspection_VPcommercial: '',
            cityStuccoWireInspectionDone: 'NO',
            cityStuccoWireInspectionDateApproved: '',
            cityStuccoWireInspectionUploadedToBT_1: 'NO',
            cityStuccoWireInspectionPMCommnets: '',
            cityStuccoWireInspectionUploadedToBT_2: 'NO',
            cityStuccoWireInspection_VPcommercial: '',
            cityElectricalRoughInspectionDone: 'NO',
            cityElectricalRoughInspectionDateApproved: '',
            cityElectricalRoughInspectionUploadedToBT_1: 'NO',
            cityElectricalRoughInspectionPMCommnets: '',
            cityElectricalRoughInspectionUploadedToBT_2: 'NO',
            cityElectricalRoughInspection_VPcommercial: '',
            cityPlumbingRoughInInspectionDone: 'NO',
            cityPlumbingRoughInInspectionDateApproved: '',
            cityPlumbingRoughInInspectionUploadedToBT_1: 'NO',
            cityPlumbingRoughInInspectionPMCommnets: '',
            cityPlumbingRoughInInspectionUploadedToBT_2: 'NO',
            cityPlumbingRoughInInspection_VPcommercial: '',
            cityInsulationInspectionDone: 'NO',
            cityInsulationInspectionDateApproved: '',
            cityInsulationInspectionUploadedToBT_1: 'NO',
            cityInsulationInspectionPMCommnets: '',
            cityInsulationInspectionUploadedToBT_2: 'NO',
            cityInsulationInspection_VPcommercial: '',
            initialBlowerDoorTestDone: 'NO',
            initialBlowerDoorTestDateApproved: '',
            initialBlowerDoorTestUploadedToBT_1: 'NO',
            initialBlowerDoorTestPMCommnets: '',
            initialBlowerDoorTestUploadedToBT_2: 'NO',
            initialBlowerDoorTest_VPcommercial: '',
            aerobarrierFinalBlowerDoorTestDone: 'NO',
            aerobarrierFinalBlowerDoorTestDateApproved: '',
            aerobarrierFinalBlowerDoorTestUploadedToBT_1: 'NO',
            aerobarrierFinalBlowerDoorTestPMCommnets: '',
            aerobarrierFinalBlowerDoorTestUploadedToBT_2: 'NO',
            aerobarrierFinalBlowerDoorTest_VPcommercial: '',
            cityFinalInspectionDone: 'NO',
            cityFinalInspectionDateApproved: '',
            cityFinalInspectionUploadedToBT_1: 'NO',
            cityFinalInspectionPMCommnets: '',
            cityFinalInspectionUploadedToBT_2: 'NO',
            cityFinalInspection_VPcommercial: '',
            heatLossCalReportDone: 'NO',
            heatLossCalReportDateApproved: '',
            heatLossCalReportUploadedToBT_1: 'NO',
            heatLossCalReportPMCommnets: '',
            heatLossCalReportUploadedToBT_2: 'NO',
            heatLossCalReport_VPcommercial: '',
        }

    },

    getScheduleMilestonesSection(sec) {
        return {
            scheduleMilestonesSection: sec,
            sitePrep_P_B_C_Date: '',
            sitePrep_C_F_C_Date: '',
            sitePrep_A_C_Date: '',
            sitePrep_Notes: '',
            sitePrep_VP_C_Comments: '',
            demolitionAndSurvey_P_B_C_Date: '',
            demolitionAndSurvey_C_F_C_Date: '',
            demolitionAndSurvey_A_C_Date: '',
            demolitionAndSurvey_Notes: '',
            demolitionAndSurvey_VP_C_Comments: '',
            footingAndFoundation_P_B_C_Date: '',
            footingAndFoundation_C_F_C_Date: '',
            footingAndFoundation_A_C_Date: '',
            footingAndFoundation_Notes: '',
            footingAndFoundation_VP_C_Comments: '',
            framing_P_B_C_Date: '',
            framing_C_F_C_Date: '',
            framing_A_C_Date: '',
            framing_Notes: '',
            framing_VP_C_Comments: '',
            roofingAndMechanical_P_B_C_Date: '',
            roofingAndMechanical_C_F_C_Date: '',
            roofingAndMechanical_A_C_Date: '',
            roofingAndMechanical_Notes: '',
            roofingAndMechanical_VP_C_Comments: '',
            exteriorFinish_P_B_C_Date: '',
            exteriorFinish_C_F_C_Date: '',
            exteriorFinish_A_C_Date: '',
            exteriorFinish_Notes: '',
            exteriorFinish_VP_C_Comments: '',
            insulationAndDrywall_P_B_C_Date: '',
            insulationAndDrywall_C_F_C_Date: '',
            insulationAndDrywall_A_C_Date: '',
            insulationAndDrywall_Notes: '',
            insulationAndDrywall_VP_C_Comments: '',
            Completion_P_B_C_Date: '',
            Completion_C_F_C_Date: '',
            Completion_A_C_Date: '',
            Completion_Notes: '',
            Completion_VP_C_Comments: '',
            turnOver_P_B_C_Date: '',
            turnOver_C_F_C_Date: '',
            turnOver_A_C_Date: '',
            turnOver_Notes: '',
            turnOver_VP_C_Comments: '',

        }
    },


    getMonthList() {
        return [
            { id: "Jan", name: "January" },
            { id: "Feb", name: "February" },
            { id: "Mar", name: "March" },
            { id: "Apr", name: "April" },
            { id: "May", name: "May" },
            { id: "Jun", name: "June" },
            { id: "Jul", name: "July" },
            { id: "Aug", name: "August" },
            { id: "Sep", name: "September" },
            { id: "Oct", name: "October" },
            { id: "Nov", name: "November" },
            { id: "Dec", name: "December" },
        ]

    },
    getMonthName(month) {
        return this.getMonthList().find(m => m.id === month).name
    },
    getRatingList() {
        return [
            { id: "0", name: "0" },
            { id: "1", name: "1" },
            { id: "2", name: "2" },
            { id: "3", name: "3" },
            { id: "4", name: "4" },
            { id: "5", name: "5" },
            { id: "6", name: "6" },
            { id: "7", name: "7" },
            { id: "8", name: "8" },
            { id: "9", name: "9" },
            { id: "10", name: "10" },
        ]
    },
    section_1_List() {
        return ["month", "vpConstructionCommentsForAll", "year", "projectId", "ProjectName", "projectAddress", "targetGp", "percentageCompletion", "costPerSF", "costPerSFAmount", "costPerSFComments", "projectOnSchedule_PM", "projectOnSchedule_PMReason", "projectOnSchedule_VPC", "projectOnSchedule_VPCReason", "tradePartnerAdvised_PM", "tradePartnerAdvised_PMReason", "tradePartnerAdvised_VPC", "tradePartnerAdvised_VPCReason", "allCityAndEngineersInspection_PM", "allCityAndEngineersInspection_PMReason", "allCityAndEngineersInspection_VPC", "allCityAndEngineersInspection_VPCReason", "projectOnBudget_PM", "projectOnBudget_PMReason", "projectOnBudget_VPC", "projectOnBudget_VPCReason", "projectBaseLineSetExecution_PM", "projectBaseLineSetExecution_PMReason", "projectBaseLineSetExecution_VPC", "projectBaseLineSetExecution_VPCReason", "anyErrorAndDeficiencies_PM", "anyErrorAndDeficiencies_PMReason", "anyErrorAndDeficiencies_VPC", "anyErrorAndDeficiencies_VPCReason", "LidaLabourInBTConsistent_PM", "LidaLabourInBTConsistent_PMReason", "LidaLabourInBTConsistent_VPC", "LidaLabourInBTConsistent_VPCReason", "pmContructorAndMaterialBT_PM", "pmContructorAndMaterialBT_PMReason", "pmContructorAndMaterialBT_VPC", "pmContructorAndMaterialBT_VPCReason", "weeklyPMClientUpdateDone_PM", "weeklyPMClientUpdateDone_PMReason", "weeklyPMClientUpdateDone_VPC", "weeklyPMClientUpdateDone_VPCReason", "haveAllTradeMaterialBeenInspected_PM", "haveAllTradeMaterialBeenInspected_PMReason", "haveAllTradeMaterialBeenInspected_VPC", "haveAllTradeMaterialBeenInspected_VPCReason", "pmQCVTTodoUptoDate_PM", "pmQCVTTodoUptoDate_PMReason", "pmQCVTTodoUptoDate_VPC", "pmQCVTTodoUptoDate_VPCReason", "poSubAggreementUptoDate_PM", "poSubAggreementUptoDate_PMReason", "poSubAggreementUptoDate_VPC", "poSubAggreementUptoDate_VPCReason", "isClientHappy_PM", "isClientHappy_PMReason", "isClientHappy_VPC", "isClientHappy_VPCReason", "riskSafetyClientTeam_PM", "riskSafetyClientTeam_PMReason", "riskSafetyClientTeam_VPC", "riskSafetyClientTeam_VPCReason", 'projectAddressVpComments', 'targetGpVpComments', 'percentageCompletionGpVpComments', 'costPerSFVpComments', 'projectAddressPmComments',]

    },
    section_2_List() {
        return ['geoTechInspectionDone', 'geoTechInspectionDateApproved', 'geoTechInspectionUploadedToBT_1', 'geoTechInspectionPMCommnets', 'geoTechInspectionUploadedToBT_2', 'geoTechInspection_VPcommercial', 'cityGroundInspectionDone', 'cityGroundInspectionDateApproved', 'cityGroundInspectionUploadedToBT_1', 'cityGroundInspectionPMCommnets', 'cityGroundInspectionUploadedToBT_2', 'cityGroundInspection_VPcommercial', 'engineerFootingInspectionDone', 'engineerFootingInspectionDateApproved', 'engineerFootingInspectionUploadedToBT_1', 'engineerFootingInspectionPMCommnets', 'engineerFootingInspectionUploadedToBT_2', 'engineerFootingInspection_VPcommercial', 'cityFootingInspectionDone', 'cityFootingInspectionDateApproved', 'cityFootingInspectionUploadedToBT_1', 'cityFootingInspectionPMCommnets', 'cityFootingInspectionUploadedToBT_2', 'cityFootingInspection_VPcommercial', 'engineeringWallInspectionDone', 'engineeringWallInspectionDateApproved', 'engineeringWallInspectionUploadedToBT_1', 'engineeringWallInspectionPMCommnets', 'engineeringWallInspectionUploadedToBT_2', 'engineeringWallInspection_VPcommercial', 'cityWallInspectionDone', 'cityWallInspectionDateApproved', 'cityWallInspectionUploadedToBT_1', 'cityWallInspectionPMCommnets', 'cityWallInspectionUploadedToBT_2', 'cityWallInspection_VPcommercial', 'cityStormDrainRWLinspectionDone', 'cityStormDrainRWLinspectionDateApproved', 'cityStormDrainRWLinspectionUploadedToBT_1', 'cityStormDrainRWLinspectionPMCommnets', 'cityStormDrainRWLinspectionUploadedToBT_2', 'cityStormDrainRWLinspection_VPcommercial', 'citySewerConnectionInspectionDone', 'citySewerConnectionInspectionDateApproved', 'citySewerConnectionInspectionUploadedToBT_1', 'citySewerConnectionInspectionPMCommnets', 'citySewerConnectionInspectionUploadedToBT_2', 'citySewerConnectionInspection_VPcommercial', 'cityPlumbingGroundRoughIninspectionDone', 'cityPlumbingGroundRoughIninspectionDateApproved', 'cityPlumbingGroundRoughIninspectionUploadedToBT_1', 'cityPlumbingGroundRoughIninspectionPMCommnets', 'cityPlumbingGroundRoughIninspectionUploadedToBT_2', 'cityPlumbingGroundRoughIninspection_VPcommercial', 'cityGroundSealInspectionDone', 'cityGroundSealInspectionDateApproved', 'cityGroundSealInspectionUploadedToBT_1', 'cityGroundSealInspectionPMCommnets', 'cityGroundSealInspectionUploadedToBT_2', 'cityGroundSealInspection_VPcommercial', 'engineeringFramingInspectionDone', 'engineeringFramingInspectionDateApproved', 'engineeringFramingInspectionUploadedToBT_1', 'engineeringFramingInspectionPMCommnets', 'engineeringFramingInspectionUploadedToBT_2', 'engineeringFramingInspection_VPcommercial', 'ventChecklistSubmittedDone', 'ventChecklistSubmittedDateApproved', 'ventChecklistSubmittedUploadedToBT_1', 'ventChecklistSubmittedPMCommnets', 'ventChecklistSubmittedUploadedToBT_2', 'ventChecklistSubmitted_VPcommercial', 'cityFramingInspectionDone', 'cityFramingInspectionDateApproved', 'cityFramingInspectionUploadedToBT_1', 'cityFramingInspectionPMCommnets', 'cityFramingInspectionUploadedToBT_2', 'cityFramingInspection_VPcommercial', 'citySheetingInspectionDone', 'citySheetingInspectionDateApproved', 'citySheetingInspectionUploadedToBT_1', 'citySheetingInspectionPMCommnets', 'citySheetingInspectionUploadedToBT_2', 'citySheetingInspection_VPcommercial', 'cityRainScreenInspectionDone', 'cityRainScreenInspectionDateApproved', 'cityRainScreenInspectionUploadedToBT_1', 'cityRainScreenInspectionPMCommnets', 'cityRainScreenInspectionUploadedToBT_2', 'cityRainScreenInspection_VPcommercial', 'cityStuccoWireInspectionDone', 'cityStuccoWireInspectionDateApproved', 'cityStuccoWireInspectionUploadedToBT_1', 'cityStuccoWireInspectionPMCommnets', 'cityStuccoWireInspectionUploadedToBT_2', 'cityStuccoWireInspection_VPcommercial', 'cityElectricalRoughInspectionDone', 'cityElectricalRoughInspectionDateApproved', 'cityElectricalRoughInspectionUploadedToBT_1', 'cityElectricalRoughInspectionPMCommnets', 'cityElectricalRoughInspectionUploadedToBT_2', 'cityElectricalRoughInspection_VPcommercial', 'cityPlumbingRoughInInspectionDone', 'cityPlumbingRoughInInspectionDateApproved', 'cityPlumbingRoughInInspectionUploadedToBT_1', 'cityPlumbingRoughInInspectionPMCommnets', 'cityPlumbingRoughInInspectionUploadedToBT_2', 'cityPlumbingRoughInInspection_VPcommercial', 'cityInsulationInspectionDone', 'cityInsulationInspectionDateApproved', 'cityInsulationInspectionUploadedToBT_1', 'cityInsulationInspectionPMCommnets', 'cityInsulationInspectionUploadedToBT_2', 'cityInsulationInspection_VPcommercial', 'initialBlowerDoorTestDone', 'initialBlowerDoorTestDateApproved', 'initialBlowerDoorTestUploadedToBT_1', 'initialBlowerDoorTestPMCommnets', 'initialBlowerDoorTestUploadedToBT_2', 'initialBlowerDoorTest_VPcommercial', 'aerobarrierFinalBlowerDoorTestDone', 'aerobarrierFinalBlowerDoorTestDateApproved', 'aerobarrierFinalBlowerDoorTestUploadedToBT_1', 'aerobarrierFinalBlowerDoorTestPMCommnets', 'aerobarrierFinalBlowerDoorTestUploadedToBT_2', 'aerobarrierFinalBlowerDoorTest_VPcommercial', 'cityFinalInspectionDone', 'cityFinalInspectionDateApproved', 'cityFinalInspectionUploadedToBT_1', 'cityFinalInspectionPMCommnets', 'cityFinalInspectionUploadedToBT_2', 'cityFinalInspection_VPcommercial', 'heatLossCalReportDone', 'heatLossCalReportDateApproved', 'heatLossCalReportUploadedToBT_1', 'heatLossCalReportPMCommnets', 'heatLossCalReportUploadedToBT_2', 'heatLossCalReport_VPcommercial',];

    },
    section_3_List() { return ["lidaHomesProjectManagement6050EHP_WINGR", "lidaHomesProjectManagement6050EPMINGR", "lidaHomesProjectManagement6050CBA", "lidaHomesProjectManagement6050BU", "lidaHomesProjectManagement6050RB", "lidaHomesProjectManagement6050COR", "lidaHomesProjectManagement6050PCD", "lidaHomesProjectManagement6050EHTCP_M", "lidaHomesProjectManagement6050EOMTC", "lidaHomesProjectManagement6050PHTC", "lidaHomesProjectManagement6050PBTC", "lidaHomesProjectManagement6050P_MB", "lidaHomesProjectManagement6050C", "specsAndBiddind0405EHP_WINGR", "specsAndBidding0405EPMINGR", "specsAndBidding0405CBA", "specsAndBidding0405BU", "specsAndBidding0405RB", "specsAndBidding0405COR", "specsAndBidding0405PCD", "specsAndBidding0405EHTCP_M", "specsAndBidding0405EOMTC", "specsAndBidding0405PHTC", "specsAndBidding0405PBTC", "specsAndBidding0405P_MB", "specsAndBidding0405C", "idAdmin0404EHP_WINGR", "idAdmin0404EPMINGR", "idAdmin0404CBA", "idAdmin0404BU", "idAdmin0404RB", "idAdmin0404COR", "idAdmin0404PCD", "idAdmin0404EHTCP_M", "idAdmin0404EOMTC", "idAdmin0404PHTC", "idAdmin0404PBTC", "idAdmin0404P_MB", "idAdmin0404C", "idSpecsAndBidding0405EHP_WINGR", "idSpecsAndBidding0405EPMINGR", "idSpecsAndBidding0405CBA", "idSpecsAndBidding0405BU", "idSpecsAndBidding0405RB", "idSpecsAndBidding0405COR", "idSpecsAndBidding0405PCD", "idSpecsAndBidding0405EHTCP_M", "idSpecsAndBidding0405EOMTC", "idSpecsAndBidding0405PHTC", "idSpecsAndBidding0405PBTC", "idSpecsAndBidding0405P_MB", "idSpecsAndBidding0405C", "flatworkPrepLabour0810EHP_WINGR", "flatworkPrepLabour0810EPMINGR", "flatworkPrepLabour0810CBA", "flatworkPrepLabour0810BU", "flatworkPrepLabour0810RB", "flatworkPrepLabour0810COR", "flatworkPrepLabour0810PCD", "flatworkPrepLabour0810EHTCP_M", "flatworkPrepLabour0810EOMTC", "flatworkPrepLabour0810PHTC", "flatworkPrepLabour0810PBTC", "flatworkPrepLabour0810P_MB", "flatworkPrepLabour0810C", "foundationMaterial0821EHP_WINGR", "foundationMaterial0821EPMINGR", "foundationMaterial0821CBA", "foundationMaterial0821BU", "foundationMaterial0821RB", "foundationMaterial0821COR", "foundationMaterial0821PCD", "foundationMaterial0821EHTCP_M", "foundationMaterial0821EOMTC", "foundationMaterial0821PHTC", "foundationMaterial0821PBTC", "foundationMaterial0821P_MB", "foundationMaterial0821C", "framing0904EHP_WINGR", "framing0904EPMINGR", "framing0904CBA", "framing0904BU", "framing0904RB", "framing0904COR", "framing0904PCD", "framing0904EHTCP_M", "framing0904EOMTC", "framing0904PHTC", "framing0904PBTC", "framing0904P_MB", "framing0904C", "backFramingLabour0906EHP_WINGR", "backFramingLabour0906EPMINGR", "backFramingLabour0906CBA", "backFramingLabour0906BU", "backFramingLabour0906RB", "backFramingLabour0906COR", "backFramingLabour0906PCD", "backFramingLabour0906EHTCP_M", "backFramingLabour0906EOMTC", "backFramingLabour0906PHTC", "backFramingLabour0906PBTC", "backFramingLabour0906P_MB", "backFramingLabour0906C", "anyOtherLidaLabour668_684_706_829EHP_WINGR", "anyOtherLidaLabour668_684_706_829EPMINGR", "anyOtherLidaLabour668_684_706_829CBA", "anyOtherLidaLabour668_684_706_829BU", "anyOtherLidaLabour668_684_706_829RB", "anyOtherLidaLabour668_684_706_829COR", "anyOtherLidaLabour668_684_706_829PCD", "anyOtherLidaLabour668_684_706_829EHTCP_M", "anyOtherLidaLabour668_684_706_829EOMTC", "anyOtherLidaLabour668_684_706_829PHTC", "anyOtherLidaLabour668_684_706_829PBTC", "anyOtherLidaLabour668_684_706_829P_MB", "anyOtherLidaLabour668_684_706_829C", "drivewayPatioPrep0830EHP_WINGR", "drivewayPatioPrep0830EPMINGR", "drivewayPatioPrep0830CBA", "drivewayPatioPrep0830BU", "drivewayPatioPrep0830RB", "drivewayPatioPrep0830COR", "drivewayPatioPrep0830PCD", "drivewayPatioPrep0830EHTCP_M", "drivewayPatioPrep0830EOMTC", "drivewayPatioPrep0830PHTC", "drivewayPatioPrep0830PBTC", "drivewayPatioPrep0830P_MB", "drivewayPatioPrep0830C",] },

    section_4_List() { return ["orgEstimatedContractDurationMonths", "actualContractDurationMonths", "monthsOfSlippageMonths", "originalExpectedGP", "originalGPMonths", "newExpectedGP", "updatedGPMonths", "gpTermsOfProjectPerMonths", "gpTermsOfProject", "perOfGPSlippage",] },

    section_5_List() { return ["markupBudget", "markupBudgetUsed", "markupRemainingBudget", "markupVPCOPSCO", "overheadBudget", "overheadBudgetUsed", "overheadRemainingBudget", "overheadVPCOPSCO", "deliveryChargeBudget", "deliveryChargeBudgetUsed", "deliveryChargeRemainingBudget", "deliveryChargeVPCOPSCO", "equipmentAndToolUsageBudget", "equipmentAndToolUsageBudgetUsed", "equipmentAndToolUsageRemainingBudget", "equipmentAndToolUsageVPCOPSCO", "liabilityInsuranceBudget", "liabilityInsuranceBudgetUsed", "liabilityInsuranceRemainingBudget", "liabilityInsuranceVPCOPSCO", "siteSafetyManagementBudget", "siteSafetyManagementBudgetUsed", "siteSafetyManagementRemainingBudget", "siteSafetyManagementVPCOPSCO", "siteSecurityStorageBudget", "siteSecurityStorageBudgetUsed", "siteSecurityStorageRemainingBudget", "siteSecurityStorageVPCOPSCO", "tempFansAndHeatersBudget", "tempFansAndHeatersBudgetUsed", "tempFansAndHeatersRemainingBudget", "tempFansAndHeatersVPCOPSCO", 'markupWhenToInvoice', 'overheadWhenToInvoice', 'deliveryChargeWhenToInvoice', 'equipmentAndToolUsageToInvoice', 'liabilityInsuranceWhenToInvoice', 'siteSafetyManagementWhenToInvoice', 'tempFansAndHeatersWhenToInvoice', 'siteSecurityStorageWhenToInvoice',] },


    section_7_List() { return ["dear", "dearVPCComments", "hereIsYourWeeklySummaryFrom", "hereIsYourWeeklySummaryTo", "hereIsYourWeeklySummaryVPCComments", "projectSummary", "projectSummaryVPCComments", "scheduleConstructionStartDate", "scheduleProjectCompletion", "scheduleVPCComments",] },

    section_8_List() { return ["sitePrep_P_B_C_Date", "sitePrep_C_F_C_Date", "sitePrep_A_C_Date", "sitePrep_Notes", "sitePrep_VP_C_Comments", "demolitionAndSurvey_P_B_C_Date", "demolitionAndSurvey_C_F_C_Date", "demolitionAndSurvey_A_C_Date", "demolitionAndSurvey_Notes", "demolitionAndSurvey_VP_C_Comments", "footingAndFoundation_P_B_C_Date", "footingAndFoundation_C_F_C_Date", "footingAndFoundation_A_C_Date", "footingAndFoundation_Notes", "footingAndFoundation_VP_C_Comments", "framing_P_B_C_Date", "framing_C_F_C_Date", "framing_A_C_Date", "framing_Notes", "framing_VP_C_Comments", "roofingAndMechanical_P_B_C_Date", "roofingAndMechanical_C_F_C_Date", "roofingAndMechanical_A_C_Date", "roofingAndMechanical_Notes", "roofingAndMechanical_VP_C_Comments", "exteriorFinish_P_B_C_Date", "exteriorFinish_C_F_C_Date", "exteriorFinish_A_C_Date", "exteriorFinish_Notes", "exteriorFinish_VP_C_Comments", "insulationAndDrywall_P_B_C_Date", "insulationAndDrywall_C_F_C_Date", "insulationAndDrywall_A_C_Date", "insulationAndDrywall_Notes", "insulationAndDrywall_VP_C_Comments", "Completion_P_B_C_Date", "Completion_C_F_C_Date", "Completion_A_C_Date", "Completion_Notes", "Completion_VP_C_Comments", "turnOver_P_B_C_Date", "turnOver_C_F_C_Date", "turnOver_A_C_Date", "turnOver_Notes", "turnOver_VP_C_Comments", "finalInvoice_P_B_C_Date", "finalInvoice_C_F_C_Date", "finalInvoice_A_C_Date", "finalInvoice_Notes", "finalInvoice_VP_C_Comments"] },

    section_11_List() { return ["contractPriceAmount", "contractPriceVPCComment", "approvedChangeOrderPrice", "approvedChangeOrderVPCComment", "allowanceDiffrence", "allowanceDiffrenceVPCComment", "jobRunningTotal", "jobRunningTotalVPCComment", "gst", "gstVPCComment", "amountPaid", "amountPaidVPCComment", "balance", "balanceVPCComment",] },
    section_12_List() { return ["contractDepositsAmount", "contractDepositsVPCComments", "buildingPermitDepositAmount", "buildingPermitDepositVPCComments", "otherDepositAmount", "otherDepositVPCComments", "totalDepositAmount", "totalDepositVPCComments",] },
    section_13_List() { return ["changeWorkOrder", "date", "amount", "approved", "notes", "VPCComments"] },
    section_15_List() { return ["address", "dateOfMeeting", "whoIsPresentForAutopsy", "projectManager", "interiorDesigner", "foreman", "projectSummary_15"] },
    section_16_List() { return ['wins', 'losses', 'whatDidWeDoWell', 'WhereCouldWeMakeImprovements', 'WhatTradesWereExcellentAndWhy', 'WhatTradesWereAProblemAndWhy'] },
    section_17_List() { return ["ProjectManager_1", "PMPOINTS_1", "VPPOINTS_1", "PMCOMMENTS_1", "VPCOCOMMENTS_1", "ProjectManager_2", "PMPOINTS_2", "VPPOINTS_2", "PMCOMMENTS_2", "VPCOCOMMENTS_2", "ProjectManager_3", "PMPOINTS_3", "VPPOINTS_3", "PMCOMMENTS_3", "VPCOCOMMENTS_3", "ProjectManager_4", "PMPOINTS_4", "VPPOINTS_4", "PMCOMMENTS_4", "VPCOCOMMENTS_4", "ProjectManager_5", "PMPOINTS_5", "VPPOINTS_5", "PMCOMMENTS_5", "VPCOCOMMENTS_5", "ProjectManager_6", "PMPOINTS_6", "VPPOINTS_6", "PMCOMMENTS_6", "VPCOCOMMENTS_6"] },
    section_18_List() { return ['ConstructionBestPratices', 'ConstructionChallenges', 'EnergyPerformanceDocument', 'SelectionOfMaterialsAndResources', 'EnergyAndWaterSavingConsiderations', 'InnovationAndDesign', 'SensitivityToSiteConditions', 'AnyDetailsNotMentionedAbove', 'SalesAndMarketingMaterial'] },



}